import React from 'react';
import { DuotoneIcons } from '../../components/Atoms/icon/duotone-icon';
import { IStoryblokLink } from '../types';
import Header, { IHeaderNavigation } from '../../containers/header/header';
import { scrollToElement } from '../../helpers/scroll-to-element';
import { mapDesktopHeaderToMobile } from '../../containers/header/helpers/map-desktop-header-to-mobile';
import { IHeaderNavigationMenu } from '../../containers/header/header-menu/header-menu';
import { getLinkUrl } from '../helpers/get-link-url';

interface IHeaderStoryblokComponentBlok {
  items: {
    title: string;
    link?: IStoryblokLink;
    menues?: {
      title: string;
      items: {
        title: string;
        description: string;
        icon: DuotoneIcons;
        link: IStoryblokLink;
      }[];
    }[];
    onClick?: () => void;
  }[];
}
export function HeadertoryblokComponent({ blok }: { blok: IHeaderStoryblokComponentBlok }) {
  const headerNavigation: IHeaderNavigation[] = blok.items.map((item) => ({
    ...item,
    link: item.link ? getLinkUrl(item.link) : undefined,
    menues: item.menues?.map((menu) => ({
      ...menu,
      items: menu.items.map((item) => ({
        ...item,
        link: getLinkUrl(item.link),
      })),
    })),
  }));

  // TODO: Remove push "Contact Us" item after "Contact Us" page implementation

  const headerNavigationWithContactUsButton = [
    ...headerNavigation,
    {
      title: 'Contact Us',
      onClick: () => scrollToElement('#connect-section'),
    },
  ];

  // TODO: Reorganize header content in Storyblok - add separate navigation configs for mobile

  const headerNavigationMobile: IHeaderNavigationMenu[] = mapDesktopHeaderToMobile(headerNavigation);

  const headerNavigationMobileWithContactUsButtonAndBlogLink = [
    {
      items: [
        {
          title: 'Contact Us',
          icon: DuotoneIcons.MOBILE,
          onClick: () => setTimeout(() => scrollToElement('#connect-section'), 500),
        },
      ],
    },
    ...headerNavigationMobile,
    {
      title: 'Company',
      items: [
        {
          title: 'Clients & dreams',
          icon: DuotoneIcons.BLOG,
          link: '/clients-and-their-dreams',
        },
      ],
    },
  ];

  return (
    <Header
      headerNavigation={headerNavigationWithContactUsButton}
      headerNavigationMobile={headerNavigationMobileWithContactUsButtonAndBlogLink}
    />
  );
}
